import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components

import { Text } from '@beef/ui-kit';
import { isStringEmpty, replaceString } from '../../../../util';

// Styles

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AccumulatorDescription = ({ accumulatorType, description }) => {
  if (accumulatorType?.caption !== null) {
    return (<Text size="size6-r" color="grey50">{accumulatorType.caption}</Text>);
  }
  if (description && !isStringEmpty(description)) {
    return (
      <span className={cx('sub-desc')}>
        <Text size="size6-r" color="grey50">
          {replaceString(description)}
        </Text>
      </span>
    );
  }
  return null;
};

AccumulatorDescription.propTypes = {
  accumulatorType: PropTypes.object,
  description: PropTypes.string,
};

export { AccumulatorDescription };
